export const parseRawNumber = (value: string,  precision:number) => {
    try {
        if (value == null || !value.toString()) {
            return 0;
        }
        var cleanUpRegex = /[^0-9\,\.]/g;
        var cleanUpSeparatorsRegex = /[\,\.]/g;
        value = value.replace(cleanUpRegex, '');

        if (value === '') {
            return 0;
        }

        var lastSeparatorPosition = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));

        if (lastSeparatorPosition === -1) {
            return parseFloat(value);
        }

        var integer = value.substring(0, lastSeparatorPosition);
        integer = integer.replace(cleanUpSeparatorsRegex, '');
        var decimal = value.substring(lastSeparatorPosition + 1, value.length);

        if (integer === '' && decimal === '') {
            return 0;
        }

        if (decimal.length > precision) {
            decimal = decimal.substring(0, precision);
        }

        return (parseFloat(integer + "." + decimal));

    } catch (e) {
        return 0;
    }
};

export const formatNumber= (num: number,decimalSeparatorForNumberFormatter:string) => {
    return num.toFixed(2).toString().replace(".", decimalSeparatorForNumberFormatter || ",");
};